/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { GetPendingSyncStateQueryResponse } from "../../models/syncStateController/GetPendingSyncState";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getPendingSyncStateQueryKey = () => [{ url: '/sync-state/pending' }] as const

export type GetPendingSyncStateQueryKey = ReturnType<typeof getPendingSyncStateQueryKey>

/**
 * {@link /sync-state/pending}
 */
export async function getPendingSyncState(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetPendingSyncStateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : `/sync-state/pending`, ... requestConfig })
  return res.data
}

export function getPendingSyncStateQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getPendingSyncStateQueryKey()
        return queryOptions<GetPendingSyncStateQueryResponse, ResponseErrorConfig<Error>, GetPendingSyncStateQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getPendingSyncState({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /sync-state/pending}
 */
export function useGetPendingSyncState<TData = GetPendingSyncStateQueryResponse, TQueryData = GetPendingSyncStateQueryResponse, TQueryKey extends QueryKey = GetPendingSyncStateQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetPendingSyncStateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getPendingSyncStateQueryKey()
         

         const query = useQuery({
          ...getPendingSyncStateQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}